<!-- Transactions List -->
<ion-list *ngIf="!isLoading" lines="none">
  <ion-item>
    <ion-label>
      <p>Filtrar por tipo:</p>
    </ion-label>
    <ion-select slot="end" interface="popover" placeholder="Todos" (ionChange)="filterTransactions($event)">
      <ion-select-option value="all">Todos</ion-select-option>
      <ion-select-option *ngIf="!brandingService.isMidiadesuerte()" value="casino">Casino</ion-select-option>
      <ion-select-option *ngIf="!brandingService.isMidiadesuerte()" value="book">SportsBook</ion-select-option>
      <ion-select-option value="refund">Reembolso</ion-select-option>
      <ion-select-option value="withdrawal">Retiro</ion-select-option>
      <ion-select-option value="deposit">Depósito</ion-select-option>
      <ion-select-option value="purchase">Juego</ion-select-option>
      <ion-select-option value="prize">Premio</ion-select-option>
      <ion-select-option value="coupon">Bono / Cupón</ion-select-option>
    </ion-select>
  </ion-item>
  <ion-item
    button
    (click)="transactionClick(transaction)"
    *ngFor="let transaction of filteredTransaction"
    [class]="
      transaction.status === 'pending' || transaction.status === 'created'
        ? 'transaction transaction-pending'
        : getType(transaction.type) === 'purchase' ||
          getType(transaction.type) === 'withdrawal' ||
          getType(transaction.type) === 'discount' ||
          getType(transaction.type) === 'transfer_out'
        ? 'transaction transaction-negative'
        : getType(transaction.type) === 'prize' ||
          getType(transaction.type) === 'deposit' ||
          getType(transaction.type) === 'refund' ||
          getType(transaction.type) === 'transfer_in' ||
          getType(transaction.type) === 'bonus' ||
          getType(transaction.type) === 'coupon'
        ? 'transaction transaction-positive'
        : 'transaction'
    "
  >
    <ion-icon
      slot="start"
      [name]="
        getType(transaction.type) === 'transfer_in'
          ? 'arrow-up'
          : getType(transaction.type) === 'transfer_out' || getType(transaction.type) === 'discount'
          ? 'arrow-down'
          : transaction.status === 'pending' || transaction.status === 'created'
          ? 'hourglass-outline'
          : transaction.status === 'declined' || transaction.status === 'cancelled'
          ? 'alert-circle-outline'
          : transaction.status === 'system_error'
          ? 'close-circle-outline'
          : undefined
      "
      [src]="
        transaction.status === 'pending' ||
        transaction.status === 'created' ||
        transaction.status === 'declined' ||
        transaction.status === 'system_error' ||
        transaction.status === 'cancelled' ||
        getType(transaction.type).includes('transfer') ||
        getType(transaction.type) === 'discount'
          ? undefined
          : getTransactionIcon(transaction.type)
      "
    ></ion-icon>
    <ion-label>
      <p class="transaction-date">{{ transaction.createdAt.toDate() | date : 'dd/MMM/yyyy, HH:mm' }}</p>
      <p>
        <span [ngSwitch]="getType(transaction)">
          <span *ngSwitchCase="'refund'"
            >Reembolso (<strong>{{
              'game.' + (transaction.data?.product ?? transaction.type.split('wallet-refund-').pop()) | translate
            }}</strong
            >)</span
          >
          <span *ngSwitchCase="'withdrawal'">{{
            transaction.type.includes('reversal') ? 'Premio cancelado' : 'Retiro'
          }}</span>
          <span *ngSwitchCase="'discount'">{{
            transaction.type.includes('reversal') ? 'Rembolso cancelado' : 'Descuento'
          }}</span>
          <span *ngSwitchCase="'transfer_in'">{{ 'Transferencia recibida' }}</span>
          <span *ngSwitchCase="'transfer_out'">{{ 'Transferencia enviada' }}</span>
          <span *ngSwitchCase="'deposit'">
            <ng-container *ngIf="transaction.data?.historical; else depositNormal">
              {{
                transaction.data?.desCategoria || transaction.data?.reason || transaction.data?.category || 'Depósito'
              }}
            </ng-container>
            <ng-template #depositNormal
              >Depósito
              <span *ngIf="transaction.data?.save?.method">
                <strong>({{ 'method.' + transaction.data?.save?.method | translate }})</strong></span
              ></ng-template
            >
          </span>
          <span *ngSwitchCase="'purchase'">
            <ng-container *ngIf="transaction.data?.historical; else purchaseNormal">
              {{ transaction.data?.desCategoria || transaction.data?.reason || transaction.data?.category || 'Juego' }}
            </ng-container>
            <ng-template #purchaseNormal
              >Juego (<strong>{{ 'game.' + transaction.type.split('wallet-purchase-').pop() | translate }}</strong
              >)</ng-template
            >
          </span>
          <span *ngSwitchCase="'prize'">
            <ng-container *ngIf="transaction.data?.historical; else prizeNormal">
              {{ transaction.data?.desCategoria || transaction.data?.reason || transaction.data?.category || 'Premio' }}
            </ng-container>
            <ng-template #prizeNormal
              >Premio (<strong>{{ 'game.' + transaction.data.product | translate }}</strong
              >)</ng-template
            >
          </span>
          <span *ngSwitchCase="'bonus'"
            >Bono liberado (<strong>{{ 'game.' + transaction.data.product | translate }}</strong
            >)</span
          >
          <span *ngSwitchCase="'coupon'">
            {{ getCouponDescription(transaction) }}
          </span>
          <span *ngSwitchDefault>Transacción</span>
        </span>
      </p>
    </ion-label>
    <!-- <ion-spinner *ngIf="transaction.status !== 'completed'" [color]="getTransactionColor(transaction.amount)" name="bubbles"></ion-spinner> -->
    <ion-text
      *ngIf="transaction.status === 'completed'"
      class="transaction-amount"
      slot="end"
      [color]="getTransactionColor(transaction.amount)"
    >
      {{ transaction.amount * (isIncrement(transaction) ? 1 : -1) | currency | slice : 0 : -3
      }}<small>.{{ transaction.amount | currency | slice : -2 }}</small>

      <ion-icon [name]="isIncrement(transaction) ? 'arrow-up-outline' : 'arrow-down-outline'"></ion-icon>
    </ion-text>
    <ion-text
      *ngIf="transaction.status !== 'completed'"
      class="transaction-amount"
      slot="end"
      [color]="getTransactionColor(transaction.amount)"
    >
      <small>{{ 'transaction.status.' + transaction.status | translate }}</small>
      <!-- <ion-icon [name]="isIncrement(transaction) ? 'arrow-up-outline' : 'arrow-down-outline'"></ion-icon> -->
    </ion-text>
  </ion-item>
  <ion-item class="pagination-controls">
    <ion-button color="dark" slot="start" fill="clear" (click)="prevPage()" [disabled]="currentPage === 1">
      <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
    </ion-button>

    <ion-label class="ion-text-center">
      <p>
        <small> {{ currentPage }} / {{ totalPages }} </small>
      </p>
    </ion-label>

    <ion-button color="dark" slot="end" fill="clear" (click)="nextPage()" [disabled]="currentPage === totalPages">
      <ion-icon slot="icon-only" name="arrow-forward-outline"></ion-icon>
    </ion-button>
  </ion-item>
</ion-list>
<app-loader *ngIf="isLoading" class="ion-padding" [isLoading]="true"></app-loader>
